import { Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

export default function Forbidden() {
  return (
    <div data-testid="forbidden-page" className="flex flex-col items-center justify-center py-20 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-50 mb-6">
        <ShieldAlert className="h-8 w-8 text-red-600" />
      </div>
      <h1 className="font-heading text-3xl font-bold text-slate-900 mb-2">Access restricted</h1>
      <p className="text-base text-slate-600 max-w-md mb-8">
        You do not have permission to view this page. This attempt has been recorded in the audit log. If you
        believe you need access, please contact your manager.
      </p>
      <Link
        to="/dashboard"
        data-testid="forbidden-back-button"
        className="inline-flex h-11 items-center rounded-md bg-primary px-6 text-sm font-semibold text-white hover:bg-brand-hover transition-colors duration-200"
      >
        Back to dashboard
      </Link>
    </div>
  );
}
